import { Instance } from "../../Base";
import Decorator from "../Decorator";

export default class TooltipDecorator extends Decorator {
  constructor(component: Instance, tooltip: string, classes: string[] = []) {
    super(component);
    const element = document.createElement("span");
    element.classList.add(...classes);
    element.innerHTML = tooltip;
    this.component.element.appendChild(element);
  }
}
